import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Layout from './pages/Layouts';
import "./assets/css/global.css";

const OpeningScreen = lazy(() => import('./pages/OpeningScreen'));
const Play = lazy(() => import('./pages/Play'));
const Prize = lazy(() => import('./pages/Prize'));

const SuspendPage = (element, fallback = <div />) => {
    return (
        <Suspense fallback={fallback}>
            {element}
        </Suspense>
    )
}

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={SuspendPage(<OpeningScreen />)} />
                    <Route path="/play" element={SuspendPage(<Play />)} />
                    <Route path="/prize" element={SuspendPage(<Prize />)} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}